import React from 'react';
import { IconHeight, IconSizes, IconWidth, IIconProps } from './type';

const Help: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = '#000',
  UNSAFE_className,
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      color={color}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM14.176 19.784V20.192H17.416V19.928C17.416 19.544 17.464 19.2 17.56 18.896C17.672 18.576 17.864 18.248 18.136 17.912C18.424 17.56 18.832 17.144 19.36 16.664C20.032 16.056 20.552 15.424 20.92 14.768C21.304 14.112 21.496 13.344 21.496 12.464C21.496 11.12 21.024 10.04 20.08 9.224C19.136 8.408 17.784 8 16.024 8C14.152 8 12.728 8.464 11.752 9.392C10.776 10.304 10.192 11.48 10 12.92L13.288 13.28C13.464 12.48 13.744 11.896 14.128 11.528C14.528 11.16 15.104 10.976 15.856 10.976C16.512 10.976 17.008 11.152 17.344 11.504C17.696 11.84 17.872 12.336 17.872 12.992C17.872 13.504 17.744 13.944 17.488 14.312C17.248 14.664 16.912 15.056 16.48 15.488C15.856 16.096 15.376 16.624 15.04 17.072C14.704 17.504 14.472 17.928 14.344 18.344C14.232 18.744 14.176 19.224 14.176 19.784ZM17.512 25.424V21.848H14.056V25.424H17.512Z"
      />
    </svg>
  );
};

export default Help;
